<section class="hvac-login-incentives">
    <ul class="hvac-login-incentives-list">
        <li class="hvac-login-incentives-list-item" *ngFor="let incentive of incentives$ | async">
            <hvac-login-incentives-item [incentive]="incentive"></hvac-login-incentives-item>
        </li>
    </ul>
</section>
